// Accounts API endpoints
//
// La liste des comptes se lit par `businessKey` (GET /accounts/{businessKey}) : les comptes viennent de la base du
// Référentiel et le backend redemande le solde au CBS à chaque lecture. Elle ne dépend donc ni du `customerCode` ni
// d'un CBS qui répond.
//
// `clientId` des deux routes suivantes est le code client CBS (`customerCode`), jamais le `businessKey`. Elles servent
// des données de démonstration : leurs boutons sont désactivés tant qu'aucune API réelle n'existe.

export const getAccountsUrl = (businessKey: string): string => {
  return `/accounts/${businessKey}`;
};

export const getAccountRibUrl = (clientId: string, accountNumber: string): string => {
  return `/customers/${clientId}/accounts/${accountNumber}/rib`;
};

export const getMiniStatementUrl = (
  clientId: string,
  accountNumber: string,
  limit?: number,
): string => {
  const base = `/customers/${clientId}/accounts/${accountNumber}/mini-statement`;
  return limit ? `${base}?limit=${limit}` : base;
};
